// extracted by mini-css-extract-plugin
module.exports = {"foodCards":"FoodGuideCards_foodCards__XhVT1"};